/* tslint:disable */

declare var Object: any;
export interface PageInterface {
  "url": string;
  "ogTitle"?: string;
  "ogDescription"?: string;
  "metaTitle"?: string;
  "metaDescription"?: string;
  "twitterText"?: string;
  "postedTweetrUrl"?: string;
  "thumbnail"?: string;
  "shareOriginalImage"?: boolean;
  "publishDate"?: Date;
  "pageType"?: string;
  "author": string;
  "view"?: string;
  "created": Date;
  "updated": Date;
  "published"?: boolean;
  "featuredInHome"?: boolean;
  "id"?: any;
  "refId"?: any;
  pageable?: any;
}

export class Page implements PageInterface {
  "url": string;
  "ogTitle": string;
  "ogDescription": string;
  "metaTitle": string;
  "metaDescription": string;
  "twitterText": string;
  "postedTweetrUrl": string;
  "thumbnail": string;
  "shareOriginalImage": boolean;
  "publishDate": Date;
  "pageType": string;
  "author": string;
  "view": string;
  "created": Date;
  "updated": Date;
  "published": boolean;
  "featuredInHome": boolean;
  "id": any;
  "refId": any;
  pageable: any;
  constructor(data?: PageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Page`.
   */
  public static getModelName() {
    return "Page";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Page for dynamic purposes.
  **/
  public static factory(data: PageInterface): Page{
    return new Page(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Page',
      plural: 'pages',
      properties: {
        "url": {
          name: 'url',
          type: 'string'
        },
        "ogTitle": {
          name: 'ogTitle',
          type: 'string'
        },
        "ogDescription": {
          name: 'ogDescription',
          type: 'string'
        },
        "metaTitle": {
          name: 'metaTitle',
          type: 'string'
        },
        "metaDescription": {
          name: 'metaDescription',
          type: 'string'
        },
        "twitterText": {
          name: 'twitterText',
          type: 'string'
        },
        "postedTweetrUrl": {
          name: 'postedTweetrUrl',
          type: 'string'
        },
        "thumbnail": {
          name: 'thumbnail',
          type: 'string'
        },
        "shareOriginalImage": {
          name: 'shareOriginalImage',
          type: 'boolean'
        },
        "publishDate": {
          name: 'publishDate',
          type: 'Date'
        },
        "pageType": {
          name: 'pageType',
          type: 'string'
        },
        "author": {
          name: 'author',
          type: 'string'
        },
        "view": {
          name: 'view',
          type: 'string'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
        "updated": {
          name: 'updated',
          type: 'Date',
          default: new Date(0)
        },
        "published": {
          name: 'published',
          type: 'boolean'
        },
        "featuredInHome": {
          name: 'featuredInHome',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "refId": {
          name: 'refId',
          type: 'any'
        },
      },
      relations: {
        pageable: {
          name: 'pageable',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Page.ts